/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Svc_Ai_Image_Pod_Automation_Cleanup_Desc7Inputs */

const en_svc_ai_image_pod_automation_cleanup_desc7 = /** @type {(inputs: Svc_Ai_Image_Pod_Automation_Cleanup_Desc7Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Clean cutouts and print-resolution files, checked before they ship.`)
};

const ar_svc_ai_image_pod_automation_cleanup_desc7 = /** @type {(inputs: Svc_Ai_Image_Pod_Automation_Cleanup_Desc7Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`قص دقيق وملفات بدقة الطباعة، تفحص قبل الإرسال.`)
};

const bn_svc_ai_image_pod_automation_cleanup_desc7 = /** @type {(inputs: Svc_Ai_Image_Pod_Automation_Cleanup_Desc7Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`পরিষ্কার কাটআউট আর প্রিন্ট-রেজোলিউশন ফাইল, পাঠানোর আগে পরীক্ষিত।`)
};

const de_svc_ai_image_pod_automation_cleanup_desc7 = /** @type {(inputs: Svc_Ai_Image_Pod_Automation_Cleanup_Desc7Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Saubere Freisteller und druckfähige Dateien, geprüft vor dem Versand.`)
};

const es_svc_ai_image_pod_automation_cleanup_desc7 = /** @type {(inputs: Svc_Ai_Image_Pod_Automation_Cleanup_Desc7Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Recortes limpios y archivos en resolución de impresión, revisados antes de enviar.`)
};

const fr_svc_ai_image_pod_automation_cleanup_desc7 = /** @type {(inputs: Svc_Ai_Image_Pod_Automation_Cleanup_Desc7Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Détourages propres et fichiers en résolution d'impression, contrôlés avant envoi.`)
};

const pt_svc_ai_image_pod_automation_cleanup_desc7 = /** @type {(inputs: Svc_Ai_Image_Pod_Automation_Cleanup_Desc7Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Recortes limpos e arquivos em resolução de impressão, revistos antes de enviar.`)
};

const zh_svc_ai_image_pod_automation_cleanup_desc7 = /** @type {(inputs: Svc_Ai_Image_Pod_Automation_Cleanup_Desc7Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`干净的抠图和打印级分辨率，发出前先检查。`)
};

const tr_svc_ai_image_pod_automation_cleanup_desc7 = /** @type {(inputs: Svc_Ai_Image_Pod_Automation_Cleanup_Desc7Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Temiz kesimler ve baskı çözünürlüklü dosyalar, göndermeden önce kontrollü.`)
};

const ru_svc_ai_image_pod_automation_cleanup_desc7 = /** @type {(inputs: Svc_Ai_Image_Pod_Automation_Cleanup_Desc7Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Чистые вырезки и файлы в печатном разрешении, проверенные перед отправкой.`)
};

const pl_svc_ai_image_pod_automation_cleanup_desc7 = /** @type {(inputs: Svc_Ai_Image_Pod_Automation_Cleanup_Desc7Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Czyste wycięcia i pliki w rozdzielczości druku, sprawdzone przed wysyłką.`)
};

/**
* | output |
* | --- |
* | "Clean cutouts and print-resolution files, checked before they ship." |
*
* @param {Svc_Ai_Image_Pod_Automation_Cleanup_Desc7Inputs} inputs
* @param {{ locale?: "en" | "ar" | "bn" | "de" | "es" | "fr" | "pt" | "zh" | "tr" | "ru" | "pl" }} options
* @returns {LocalizedString}
*/
const svc_ai_image_pod_automation_cleanup_desc7 = /** @type {((inputs?: Svc_Ai_Image_Pod_Automation_Cleanup_Desc7Inputs, options?: { locale?: "en" | "ar" | "bn" | "de" | "es" | "fr" | "pt" | "zh" | "tr" | "ru" | "pl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Svc_Ai_Image_Pod_Automation_Cleanup_Desc7Inputs, { locale?: "en" | "ar" | "bn" | "de" | "es" | "fr" | "pt" | "zh" | "tr" | "ru" | "pl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "ar") return ar_svc_ai_image_pod_automation_cleanup_desc7(inputs)
	if (locale === "bn") return bn_svc_ai_image_pod_automation_cleanup_desc7(inputs)
	if (locale === "de") return de_svc_ai_image_pod_automation_cleanup_desc7(inputs)
	if (locale === "es") return es_svc_ai_image_pod_automation_cleanup_desc7(inputs)
	if (locale === "fr") return fr_svc_ai_image_pod_automation_cleanup_desc7(inputs)
	if (locale === "pt") return pt_svc_ai_image_pod_automation_cleanup_desc7(inputs)
	if (locale === "zh") return zh_svc_ai_image_pod_automation_cleanup_desc7(inputs)
	if (locale === "tr") return tr_svc_ai_image_pod_automation_cleanup_desc7(inputs)
	if (locale === "ru") return ru_svc_ai_image_pod_automation_cleanup_desc7(inputs)
	if (locale === "pl") return pl_svc_ai_image_pod_automation_cleanup_desc7(inputs)
	return en_svc_ai_image_pod_automation_cleanup_desc7(inputs)
});
export { svc_ai_image_pod_automation_cleanup_desc7 as "svc_ai-image-pod-automation_CLEANUP_desc" }